import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';
import { Dictionary } from '../constants/dictionary.constant';

export const tabOptions = (data) => {
	return [
		{
			key: 'requested',
			tab: Dictionary[Enviroment.LANGUAGE].requested,
			data: data,
			status: 'requested',
		},
		{
			key: 'completed',
			tab: Dictionary[Enviroment.LANGUAGE].completed,
			data: data,
			status: 'completed',
		},
		{
			key: 'canceled',
			tab: Dictionary[Enviroment.LANGUAGE].cancelled,
			data: data,
			status: 'canceled',
		}
	];
};
